<template>
    <main class="ticket-page">
        <section class="ticket-card">
            <div class="ticket-header">
                <h5 class="ticket-title">تیکت های مشتریان</h5>
                <p class="ticket-subtitle">لطفاً نوع تیکت مورد نظر را انتخاب کنید</p>
            </div>

            <div class="ticket-actions">
                <button
                    type="button"
                    class="ticket-btn ticket-btn-return"
                    @click="goToReturns"
                >
                    <span class="ticket-btn-title">مرجوعی</span>
                    <span class="ticket-btn-desc">مدیریت تیکت های مرجوعی</span>
                </button>

                <button
                    type="button"
                    class="ticket-btn ticket-btn-support"
                    @click="goToSupport"
                >
                    <span class="ticket-btn-title">پشتیبانی</span>
                    <span class="ticket-btn-desc">مدیریت تیکت های پشتیبانی</span>
                </button>
            </div>
        </section>
    </main>
</template>

<script>
import configProvider from "@@/core/configProvider";
import mixins from "@@/core/mixins/mixins";

export default {
    name: "ticketManagement",
    mixins: [mixins],
    configProvider,

    data() {
        return {};
    },

    methods: {
        goToReturns() {
            this.$router.push(`/admin/tickets-list?type=refund`);
        },

        goToSupport() {
            this.$router.push(`/admin/tickets-list?type=support`);
        },
    },
};
</script>

<style scoped src="@@/core/pages/ticketManagement/ticketManagement.css"></style>